import angular from 'angular';

import { userService, loaderService, reportsSharedModelService } from 'app/services';
import { actionIcon } from 'app/components/global';

import reportPackages from './reportPackages';
import reportPackageSummaries from './reportPackageSummaries';
import addReportPackageDialog from './dialog.addReportPackage';
import directive from './package-reports.directive';
import controller from './package-reports.controller';

export const packageReportsRouteConfig = {
  template: require('./package-reports.html'),
  controller: 'PackageReportsController',
  controllerAs: 'packageReportsVM',
};

export default angular
  .module('app.components.reports.packageReports', [
    userService,
    loaderService,
    reportsSharedModelService,
    actionIcon,
    reportPackages,
    reportPackageSummaries,
    addReportPackageDialog,
  ])
  .directive('packageReports', directive)
  .controller('PackageReportsController', controller).name;

console.log('app.components.reports.packageReports created');
